<template>
  <div class="js-basedata-cargroup app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('baseData.terminalmanage.terminalInfo.searchWidth.width1')">
              <el-form-item :label="$t('public.obdCode') + '：'">
                <el-input v-model="listQuery.barcode" filterable clearable :placeholder="$t('public.obdCode')" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('baseData.terminalmanage.terminalInfo.searchWidth.width2')">
              <el-form-item :label="$t('public.createTime')+'：'">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span class="time-span" style="color:#ddd;">——</span>&emsp;
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter=true"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-export="handleExport"
      @click-right-import="handleRightImport"
      @click-import="handleImport"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      size='mini'
      v-loading="listLoading"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @current-change="handleCurrentRowChange"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop=='changeUp'|| item.prop=='timedUp'">
            <span>
              {{ scope.row[item.prop]===0? $t('public.close') : !scope.row[item.prop] ? '/': `${$t('public.startUp')} (${scope.row[item.prop] })`  }}
            </span>
          </div>
          <div v-else-if="item.prop==='threeAixWakeupValue' || item.prop==='drivingBoard' || item.prop==='ontimeWakeupDelayValue'">
            <span>{{ scope.row[item.prop]===0 ? 
            $t('public.close') 
            : scope.row[item.prop]>0 ? 
            $t('public.opens')  : '/' }}</span>
          </div> 
           <div v-else-if="item.prop==='bindingState'">
            <span>{{ scope.row[item.prop]===0 ? 
            $t('baseData.terminalmanage.terminalInfo.unbind') : 
            $t('baseData.terminalmanage.terminalInfo.binding')}}</span>
          </div> 
          <!-- <div v-else-if="item.prop==='ontimeWakeupDelayValue'">
            <span>{{ scope.row[item.prop]===0 ?  
            $t('public.close')  :
            scope.row[item.prop]>0 ? 
              $t('public.opens') :'/' }}</span>
          </div>  -->
          <div v-else>{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</div>          
        </template>
      </el-table-column>
      <el-table-column :label="$t('public.operation')" align="center" width="130">
        <template slot-scope="scope">
          <el-tag type="default" @click="lookHistory(scope.row)">
            {{$t('baseData.terminalmanage.terminalInfo.seeHistory')}}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增编辑dialog弹窗 -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit ? currentRow : {}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
    <import-dialog 
    :action="importDataConifg.importUrl"
    :template-url="importDataConifg.importTmp"
    :visibles.sync="importVisible"
    @upload-success="reloadList"
     >
      <result-dialog
      :visibles.sync="resultVisible"
      :data="importResult"
      :text="importDataConifg.text"
      :keys="'terminal'"
      :message="$t('baseData.terminalmanage.terminalInfo.message.noImportInfo')"
      :is-show="importDataConifg.show"
      @export-fail="exportFail"
      >
      
      </result-dialog>
    </import-dialog>

    <history-dialog
      :visible.sync="historyVisible"
      :data="currentRow"
    />
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
import importDialog from '@/components/importDialog'
import resultDialog from '@/components/resultDialog'
import historyDialog from './components/lookHistory'
// request
import { getTerminalList, deleteTerminalCode, exportTerminal, exportCheckTerminal } from '@/api/obdDevice/manage'
export default {
  name: 'terminal',
  components: { AddUpdateDialog, importDialog, historyDialog, resultDialog },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle,getPageButton],
  data() {
    return {
      listQuery: {},
      importDataConifg: {},
      showfilter: false,
      tableList: [
        { value: this.$t('baseData.terminalmanage.terminalInfo.terminalNumber'), prop: 'terminalCode', position: 'center', width: this.$t('baseData.terminalmanage.terminalInfo.tableWidth'),  sortable: 'custom', checked: true },
      //  { value: this.$t('baseData.terminalmanage.terminalInfo.terminalBarcode'), prop: 'barcode', position: 'center',  width: '240', checked: true },
        { value: this.$t('public.obdCode'), prop: 'barcode', position: 'center',  width: '120', checked: true },
        { value: this.$t('public.sim'), prop: 'sim', position: 'center',  width: '120', sortable: 'custom', checked: true },
        { value: this.$t('public.iccid'), prop: 'iccId', position: 'center',  width: '120', sortable: 'custom', checked: true },

        { value: this.$t('baseData.terminalmanage.terminalInfo.wakeUpTimeInterval'), prop: 'onTimeWakeUpDelayValue', position: 'center',  width: '180', sortable: 'custom', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.wakeUpTimeKeepDuration'), prop: 'onTimeWakeUpKeepTime', position: 'center',  width: '220', sortable: 'custom', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.unusualAlarmingValue'), prop: 'threeAixWakeUpValue', position: 'center',  width: '180', sortable: 'custom', checked: true },

        { value: this.$t('baseData.terminalmanage.terminalInfo.IOstate'), prop: 'IO', position: 'center',  width: '200', checked: true },
        { value: this.$t('public.driveSmallPlate'), prop: 'drivingBoard', position: 'center',  width: '120', sortable: 'custom', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.Version'), prop: 'firmware', position: 'center',  width: '160', sortable: 'custom', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.bindingState'), prop: 'bindingState', position: 'center',  width: '160', sortable: 'custom', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.authorize'), prop: 'authorize', position: 'center',  width: '160', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.founder'), prop: 'createdBy', position: 'center',  width: '100', sortable: 'custom', checked: true },
        { value: this.$t('baseData.terminalmanage.terminalInfo.creationTime'), prop: 'createdOn', position: 'center',width: '150', sortable: 'custom', checked: true },
        { value: this.$t('public.expirationTime'), prop: 'expireTime', position: 'center', sortable: 'custom', width: '150', checked: true },
        // { value: this.$t('public.upgradeTime'), prop: 'upgradeTime', position: 'center', checked: true },
        { value: this.$t('public.note'), prop: 'note', position: 'center',width: '150', checked: true }
      ],
      authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false,
      importVisible: false,
      resultVisible: false,
      importResult: {},
      historyVisible: false,
      isEdit: false,
      currentRow: null
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {
  },
  methods: {
    // 导入成功之后刷新list
    reloadList(data) {
      this.importResult = data
      this.resultVisible = true
      this.listLoad()
    },
    // 导出失败信息
    exportFail(data){
      exportCheckTerminal(data)
    },
    // 加载数据
    listLoad() {
      let startTime = new Date(this.listQuery.startTime).getTime()
        let endTime = new Date(this.listQuery.endTime).getTime()
        if(startTime>endTime){
          this.$message.error({
            message: this.$t('public.timeError'),
             duration: 2 * 1000
          })
          return
        }
      this.listLoading = true
      getTerminalList(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          const result = data.data || []
          this.list = result.map(item=>{
            const {io1,io2,io3,io4} = item
            const ioArr = [io1,io2,io3,io4]
            item.IO = ioArr.map(v=>this.getIo(v)).join(' , ')
            return item
          })
          this.total = data.total
          const orderSort = 'terminalCode,barcode,createdBy,createdOn'
          this.setOrderField(orderSort, this.tableList)
        }
      }).finally(()=>{
        this.listLoading = false
      })
    },
    getIo(val) {
      return val>0 ? this.$t('public.opens') : val === 0 ? this.$t('public.close') : ' / '
      
    },
    /**
     * 检测是否未选择
     */
    checkCurrentRowEmpty () {
      return !this.currentRow
    },
    handleCurrentRowChange (val) {
      this.currentRow = val
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增成功
    addComplete() {
      this.listLoad()
    },
    // 编辑
    handleUpdate() {
      if (!this.checkCurrentRowEmpty()) {
        this.isEdit = true
        this.addUpdateVisible = true
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
    },
    // 删除
    handleDelete() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      const deleteData = {
        terminalId: this.currentRow.terminalId,
        barcode: this.currentRow.barcode
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteTerminalCode(deleteData).then(({ data }) => {
            if (data.code === 0) {
              this.listLoad()
            }
          })
        })
    },

    // 导出
    handleExport() {
      const {  barcode , starttime, endTime  } = this.listQuery
      const postData = {
        barcode , starttime, endTime
      }
      exportTerminal(postData)
    },
    // 导入
    handleImport() {
      this.importVisible = true
      this.importDataConifg.importUrl =  process.env.VUE_APP_BASEURL + '/terminal/importTerminal'
      this.importDataConifg.importTmp = '/file/upload/template/TerminalCodeImport.xlsx'
      this.importDataConifg.text = this.$t('public.obdCode')
      this.importDataConifg.show = true
    },
    // 批量更新
    handleRightImport() {
      this.importVisible = true
      this.importDataConifg.importUrl =  process.env.VUE_APP_BASEURL + '/terminal/importAndUpdate'
      this.importDataConifg.importTmp = '/file/upload/template/TerminalCodeUpdate.xlsx'
      this.importDataConifg.text = this.$t('public.obdCode')
      this.importDataConifg.show = true
    },
    // 查看历史记录
    lookHistory(row) {
      this.currentRow = row
      this.historyVisible = true
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
